import React from "react";

import { Container } from "./styles";

interface TooltipProps {
  title?: string;
  className?: string;
  customStyle?: string;
  children: React.ReactNode;
  /* Repassados ao <span> da mensagem, nao ao contêiner: sao o que liga o
     texto do erro ao input via aria-describedby e o anuncia ao aparecer. */
  id?: string;
  role?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  className = "",
  title,
  ...rest
}) => (
  <Container className={className}>
    {children}
    {/* A classe é o gancho que o campo usa para revelar a mensagem quando ele
        recebe foco — o alvo do hover (o ícone) não é focável, então sem isto
        a mensagem só existiria para quem usa mouse. */}
    <span className="tooltip-message" {...rest}>
      {title}
    </span>
  </Container>
);

export default Tooltip;
